import { useTranslation } from 'react-i18next';

import type { AiItem } from '@/api/aiPipeline';
import { Pill } from '@/components/ui/Pill';
import { useIeltsTypeLabel } from '@/hooks/useIeltsTypeLabel';

/** Значки конвейера: одинаковые в очереди, ходе генерации и карточке. */

export function StatePill({ state }: { state: string }) {
  const { t } = useTranslation();
  const variant = state === 'done' ? 'success' : state === 'error' ? 'danger' : 'primary';
  return <Pill variant={variant}>{t(`adminAiPipeline.state.${state}`, state)}</Pill>;
}

export function ChecksPill({ passed }: { passed: boolean | null | undefined }) {
  const { t } = useTranslation();
  if (passed === true) return <Pill variant="success">{t('adminAiPipeline.checks.passed')}</Pill>;
  if (passed === false) return <Pill variant="warning">{t('adminAiPipeline.checks.failed')}</Pill>;
  return <Pill>{t('adminAiPipeline.checks.unknown')}</Pill>;
}

export function ReviewPill({ status }: { status: string }) {
  const { t } = useTranslation();
  const variant = status === 'approved' ? 'success' : status === 'rejected' ? 'danger' : 'neutral';
  return <Pill variant={variant}>{t(`adminAiPipeline.review.${status}`, status || '—')}</Pill>;
}

export function RunPill({ status }: { status: string }) {
  const { t } = useTranslation();
  const variant = status === 'ok' ? 'success' : status === 'fail' ? 'warning' : status === 'error' ? 'danger' : 'primary';
  return <Pill variant={variant}>{t(`adminAiPipeline.run.${status}`, status)}</Pill>;
}

/** «качество: прошло» — итог проверки у задания или у вердикта. */
export function PassPill({ label, pass }: { label: string; pass: boolean | null | undefined }) {
  const { t } = useTranslation();
  if (pass === true) return <Pill variant="success">{t('adminAiPipeline.content.passed', { check: label })}</Pill>;
  if (pass === false) return <Pill variant="warning">{t('adminAiPipeline.content.failed', { check: label })}</Pill>;
  return <Pill>{t('adminAiPipeline.content.unknownCheck', { check: label })}</Pill>;
}

/** Что заказано: виды заданий, вид и подвид письма или набор речи. */
export function ItemKinds({ item }: { item: Pick<AiItem, 'skill' | 'types' | 'writing_kind' | 'writing_subtype'> }) {
  const { t } = useTranslation();
  const typeLabel = useIeltsTypeLabel();
  let text = '';
  if (item.skill === 'writing') {
    text = [
      item.writing_kind ? t(`adminAiPipeline.kind.${item.writing_kind}`, item.writing_kind) : '',
      item.writing_subtype ? t(`adminAiPipeline.subtype.${item.writing_subtype}`, item.writing_subtype) : '',
    ]
      .filter(Boolean)
      .join(' · ');
  } else if (item.skill === 'speaking') {
    text = t('adminAiPipeline.speakingParts');
  } else {
    text = (item.types ?? []).map(typeLabel).join(', ');
  }
  return <>{text || '—'}</>;
}
